import clsx from 'clsx';
import React, { type ReactElement } from 'react';

import IconQuote from '@components/Images/Rebranding/IconQuote';

import type { QuotationProps } from './interfaces';

const Quotation = ({ isPro = true, quote, source, title }: QuotationProps): ReactElement => {
  return (
    <article className="m-auto flex w-full flex-col gap-16 lg:flex-row lg:items-start">
      <IconQuote
        className={clsx('w-48 shrink-0', {
          'text-pro-gold': isPro,
          'text-primary-magenta': !isPro,
        })}
      />
      <div>
        <blockquote className="m-0 font-suisse-neue text-body-md font-normal text-grayscale-charcoal md:text-body-lg">
          {quote}”
        </blockquote>
        {(source || title) && (
          <cite className="m-0 mt-8 block font-suisse-screen text-byline-sm not-italic text-grayscale-charcoal md:mt-16 md:text-byline-md">
            {source && <span className="font-bold">— {source}</span>}
            {title && `, ${title}`}
          </cite>
        )}
      </div>
    </article>
  );
};

export default Quotation;
